import { AnimatePresence, AnimatePresenceProps } from 'framer-motion';

const SafeAnimatePresence: React.FC<AnimatePresenceProps> = (props) => {
  return AnimatePresence(props) ?? null;
};

export default SafeAnimatePresence;
